
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as logindGU_Y4tTcWsCg9HnKfbgxniTJNnqn8Xqf4N3mbSf_459QMeta } from "/opt/build/repo/pages/login.vue?macro=true";
import { default as confirmtfJjcehsAXgzDoakAZcw6ceepd_45_Z6xWt3OaWc4DvHwMeta } from "/opt/build/repo/pages/confirm.vue?macro=true";
import { default as pricingRbjPV4QgNwPGQ_45ACV11_FJIFdQzL5emOzir_45tH5GJ0wMeta } from "/opt/build/repo/pages/pricing.vue?macro=true";
import { default as sign_45upsbyFTKzb27ZDAAG4Ck628G_45pZQrSR_Bg9SgR2KtFDGcMeta } from "/opt/build/repo/pages/sign-up.vue?macro=true";
import { default as about_4564pMfQbLMFHtaGEWOUOd_45j5Lt0LKY87E3Tr9f6RP1M18kMeta } from "/opt/build/repo/pages/about-64.vue?macro=true";
import { default as registereUFPUgCXbUbkM74KdKqZIrJcc_QOIXBANMYTn5YpRlAMeta } from "/opt/build/repo/pages/register.vue?macro=true";
import { default as _91_46_46_46slug_93bxqMJRabVdWZXuvF9FWZmMIujcSvRxUBxs5JzQp4EB0Meta } from "/opt/build/repo/pages/[...slug].vue?macro=true";
import { default as _91id_93mJD2WVi2JYFSlLG73Q15BAV79E_6Q4VXXKSMMWtj62wMeta } from "/opt/build/repo/pages/teams/[id].vue?macro=true";
import { default as portal_45passZQw1NSPcqOntt5w_yTeO_VNm8znngBGA1U4szy61f7YMeta } from "/opt/build/repo/pages/portal-pass.vue?macro=true";
import { default as indexXO3bxw3O7XPUwHKBpkkcq4lFUEUaKv_t0fsoJgbttmIMeta } from "/opt/build/repo/pages/teams/index.vue?macro=true";
import { default as _91id_93ixz3SGWjZ71ipCtgV4ZakENWi_CPGUgrH3F15AvzxcIMeta } from "/opt/build/repo/pages/players/[id].vue?macro=true";
import { default as index4WSA4gBF02aJHzs3Wa2azWU6lDIK7fEqsaJqHVDaotIMeta } from "/opt/build/repo/pages/players/index.vue?macro=true";
import { default as indexb_FS5UICZ4Myp5httq0wijzLjXYQESxOQh7N542_457t8Meta } from "/opt/build/repo/pages/articles/index.vue?macro=true";
import { default as privacy_45policyPl1ixjl54PV0rmR_45TVWtLEI_4n7GqlEsEe__45AeHGvHsMeta } from "/opt/build/repo/pages/privacy-policy.vue?macro=true";
import { default as reset_45password2S4NlOq3P1ZR9XrtNBf0_GEwuTrW3VEUJcKJFtfVRKcMeta } from "/opt/build/repo/pages/reset-password.vue?macro=true";
import { default as indexCH4F9n0cmqJYQ7a20Aw_45Av3Fos_vFIp40pTfub0W8JcMeta } from "/opt/build/repo/pages/the-board/index.vue?macro=true";
import { default as indexPpgtHzfNUBa933vAbxIhcrIcSBNwec6AbXqaBt_45L_6oMeta } from "/opt/build/repo/pages/my-account/index.vue?macro=true";
import { default as terms_45of_45service98Sl0B0s_45g1s2xKjJxHo5NIQaSuNWr6QRk_45t4WriR78Meta } from "/opt/build/repo/pages/terms-of-service.vue?macro=true";
import { default as indexwfD1xWTNEdXgkcze5jMb3OLIJ_4564jm8KkqdCHOi_4tAMeta } from "/opt/build/repo/pages/admin/games/index.vue?macro=true";
import { default as indexSHaKMqebudvOtNNbcviCULmMvkh6O5sZqA_QneN1HCkMeta } from "/opt/build/repo/pages/admin/plays/index.vue?macro=true";
import { default as indexR5w_4AYXRa_45CxVghXyOnsn2fT1gSATJVZqRUYY1diDwMeta } from "/opt/build/repo/pages/conferences/index.vue?macro=true";
import { default as _91_46_46_46slug_93_45LTnuOBfg10_iChYkS9L1n8CoQgNS1P_45rY29D6WB_455IMeta } from "/opt/build/repo/pages/articles/[...slug].vue?macro=true";
import { default as indexZTlTUf6aiY4K4ypAsmIPXJS0J_45UCq_45esNPO1rRTupfYMeta } from "/opt/build/repo/pages/confirmation/index.vue?macro=true";
import { default as indexjvs59EGO0PP_8mtuclnNCXo7S9mExTYz_sASC7ABBgMMeta } from "/opt/build/repo/pages/members-area/index.vue?macro=true";
import { default as next_45stepsFyqZHefz0QzT_MyFhL32QLI_4569cry80lKPlLmTmmq14Meta } from "/opt/build/repo/pages/password/next-steps.vue?macro=true";
import { default as hittingykLhMhRP_45MEH1nMJkIM7HSU6Er0ZwyzpYCaznSLYXUIMeta } from "/opt/build/repo/pages/stats/teams/hitting.vue?macro=true";
import { default as indexTw6ax_45yA1vv8lIZuWoG1piXo7SRw_3KxCZtpEzGkrY0Meta } from "/opt/build/repo/pages/rankings/teams/index.vue?macro=true";
import { default as pitchingfmYd7dB5JtAuL7FqsTdDdYxSQDHysZnjCQ4madCaDCQMeta } from "/opt/build/repo/pages/stats/teams/pitching.vue?macro=true";
import { default as teams0VDqdf7vqjo_NU_45ybzpg33OZy9MxwzC2K3fWod7t0xwMeta } from "/opt/build/repo/pages/rankings/portal/teams.vue?macro=true";
import { default as hittingaI3ZXCdcGkkR8tX5u5NNtOvAqpFD2nI2qnCeajXC3XoMeta } from "/opt/build/repo/pages/stats/players/hitting.vue?macro=true";
import { default as hittingO8mLDV93TXkkPvjH7Z8j8zMQUFzQt2RAVJykKxyuH0MMeta } from "/opt/build/repo/pages/rankings/teams/hitting.vue?macro=true";
import { default as single_45userEE7uQie9GgkLQwGO5n3cvvYYPH8n_45WsPKqlgFiDG3MUMeta } from "/opt/build/repo/pages/restricted/single-user.vue?macro=true";
import { default as pitchingFO8igK7mugkSrPskwsXsjQAg7eIuTElGwd41TtJZh6wMeta } from "/opt/build/repo/pages/stats/players/pitching.vue?macro=true";
import { default as indexekWD2MPEGUjo_K0A60rx85Di0B2uMDznpcoirrJ6QhwMeta } from "/opt/build/repo/pages/admin/data-import/index.vue?macro=true";
import { default as player_45notesNjLF_ztOJjf5mhLh5hZaFL0c8mUkEQpyoKsS2FHyZ2AMeta } from "/opt/build/repo/pages/my-account/player-notes.vue?macro=true";
import { default as hittingItrcuem_5FQgtqpH_OIs2buap1FctSwe0eeNIBZs2VwMeta } from "/opt/build/repo/pages/rankings/player/hitting.vue?macro=true";
import { default as playersvylenMjELhPojabG5U_45_FB34OKv7VvDY6vQDGvdmNjsMeta } from "/opt/build/repo/pages/rankings/portal/players.vue?macro=true";
import { default as pitching886_45zpl7qpL79kPQmZ0XjvDF19aGwX9LavCprxsbP_cMeta } from "/opt/build/repo/pages/rankings/teams/pitching.vue?macro=true";
import { default as index5zAi89Qx6adg1q_0T_45Xpx4F_45KX01aRdqGcDRgvwfb34Meta } from "/opt/build/repo/pages/confirmation/email/index.vue?macro=true";
import { default as indextxVhsXzSC20Rl8g9idFz3IW7zRQFC_45MvwwVs10qWCdMMeta } from "/opt/build/repo/pages/confirmation/trial/index.vue?macro=true";
import { default as pitching5JhYKKEbxxaKS_45SfusIQM2BJxWwzZP3aJQzxMiSH9LEMeta } from "/opt/build/repo/pages/rankings/player/pitching.vue?macro=true";
import { default as indexuxLGV5Bx1znOSsmAxuYY6HCFvdc3I8z5MsAHyecgwfEMeta } from "/opt/build/repo/pages/admin/subscriptions/index.vue?macro=true";
import { default as indexiRbRZ8Y1yEfcXc8F5SkYNJ2hUrTmcpN1J2Rt7JdSHucMeta } from "/opt/build/repo/pages/confirmation/subscription/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":"redirect-if-logged-in"},
    component: () => import("/opt/build/repo/pages/login.vue")
  },
  {
    name: "confirm",
    path: "/confirm",
    component: () => import("/opt/build/repo/pages/confirm.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/opt/build/repo/pages/pricing.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: {"middleware":"redirect-if-logged-in"},
    component: () => import("/opt/build/repo/pages/sign-up.vue")
  },
  {
    name: "about-64",
    path: "/about-64",
    component: () => import("/opt/build/repo/pages/about-64.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: {"middleware":"redirect-if-logged-in"},
    component: () => import("/opt/build/repo/pages/register.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/[...slug].vue")
  },
  {
    name: "teams-id",
    path: "/teams/:id()",
    component: () => import("/opt/build/repo/pages/teams/[id].vue")
  },
  {
    name: "portal-pass",
    path: "/portal-pass",
    component: () => import("/opt/build/repo/pages/portal-pass.vue")
  },
  {
    name: "teams",
    path: "/teams",
    component: () => import("/opt/build/repo/pages/teams/index.vue")
  },
  {
    name: "players-id",
    path: "/players/:id()",
    component: () => import("/opt/build/repo/pages/players/[id].vue")
  },
  {
    name: "players",
    path: "/players",
    component: () => import("/opt/build/repo/pages/players/index.vue")
  },
  {
    name: "articles",
    path: "/articles",
    component: () => import("/opt/build/repo/pages/articles/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/opt/build/repo/pages/privacy-policy.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/opt/build/repo/pages/reset-password.vue")
  },
  {
    name: "the-board",
    path: "/the-board",
    meta: indexCH4F9n0cmqJYQ7a20Aw_45Av3Fos_vFIp40pTfub0W8JcMeta || {},
    component: () => import("/opt/build/repo/pages/the-board/index.vue")
  },
  {
    name: "my-account",
    path: "/my-account",
    component: () => import("/opt/build/repo/pages/my-account/index.vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    component: () => import("/opt/build/repo/pages/terms-of-service.vue")
  },
  {
    name: "admin-games",
    path: "/admin/games",
    component: () => import("/opt/build/repo/pages/admin/games/index.vue")
  },
  {
    name: "admin-plays",
    path: "/admin/plays",
    component: () => import("/opt/build/repo/pages/admin/plays/index.vue")
  },
  {
    name: "conferences",
    path: "/conferences",
    component: () => import("/opt/build/repo/pages/conferences/index.vue")
  },
  {
    name: "articles-slug",
    path: "/articles/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/articles/[...slug].vue")
  },
  {
    name: "confirmation",
    path: "/confirmation",
    component: () => import("/opt/build/repo/pages/confirmation/index.vue")
  },
  {
    name: "members-area",
    path: "/members-area",
    component: () => import("/opt/build/repo/pages/members-area/index.vue")
  },
  {
    name: "password-next-steps",
    path: "/password/next-steps",
    component: () => import("/opt/build/repo/pages/password/next-steps.vue")
  },
  {
    name: "stats-teams-hitting",
    path: "/stats/teams/hitting",
    component: () => import("/opt/build/repo/pages/stats/teams/hitting.vue")
  },
  {
    name: "rankings-teams",
    path: "/rankings/teams",
    component: () => import("/opt/build/repo/pages/rankings/teams/index.vue")
  },
  {
    name: "stats-teams-pitching",
    path: "/stats/teams/pitching",
    component: () => import("/opt/build/repo/pages/stats/teams/pitching.vue")
  },
  {
    name: "rankings-portal-teams",
    path: "/rankings/portal/teams",
    component: () => import("/opt/build/repo/pages/rankings/portal/teams.vue")
  },
  {
    name: "stats-players-hitting",
    path: "/stats/players/hitting",
    component: () => import("/opt/build/repo/pages/stats/players/hitting.vue")
  },
  {
    name: "rankings-teams-hitting",
    path: "/rankings/teams/hitting",
    component: () => import("/opt/build/repo/pages/rankings/teams/hitting.vue")
  },
  {
    name: "restricted-single-user",
    path: "/restricted/single-user",
    component: () => import("/opt/build/repo/pages/restricted/single-user.vue")
  },
  {
    name: "stats-players-pitching",
    path: "/stats/players/pitching",
    component: () => import("/opt/build/repo/pages/stats/players/pitching.vue")
  },
  {
    name: "admin-data-import",
    path: "/admin/data-import",
    component: () => import("/opt/build/repo/pages/admin/data-import/index.vue")
  },
  {
    name: "my-account-player-notes",
    path: "/my-account/player-notes",
    component: () => import("/opt/build/repo/pages/my-account/player-notes.vue")
  },
  {
    name: "rankings-player-hitting",
    path: "/rankings/player/hitting",
    component: () => import("/opt/build/repo/pages/rankings/player/hitting.vue")
  },
  {
    name: "rankings-portal-players",
    path: "/rankings/portal/players",
    component: () => import("/opt/build/repo/pages/rankings/portal/players.vue")
  },
  {
    name: "rankings-teams-pitching",
    path: "/rankings/teams/pitching",
    component: () => import("/opt/build/repo/pages/rankings/teams/pitching.vue")
  },
  {
    name: "confirmation-email",
    path: "/confirmation/email",
    component: () => import("/opt/build/repo/pages/confirmation/email/index.vue")
  },
  {
    name: "confirmation-trial",
    path: "/confirmation/trial",
    component: () => import("/opt/build/repo/pages/confirmation/trial/index.vue")
  },
  {
    name: "rankings-player-pitching",
    path: "/rankings/player/pitching",
    component: () => import("/opt/build/repo/pages/rankings/player/pitching.vue")
  },
  {
    name: "admin-subscriptions",
    path: "/admin/subscriptions",
    component: () => import("/opt/build/repo/pages/admin/subscriptions/index.vue")
  },
  {
    name: "confirmation-subscription",
    path: "/confirmation/subscription",
    component: () => import("/opt/build/repo/pages/confirmation/subscription/index.vue")
  }
]